













































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
	DeviceSearchModel,
	DeviceEventRecords,
	DeviceCamera,
	CameraRecordingState,
} from "@/store/video-reporting/types";
import { VideoReportingStates } from "@/store/video-reporting/types";
import { CameraRecord } from "@/store/video-reporting/types";
import { AuditService } from "@/services/auditService";

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";

const VideoReportingStore = namespace("videoReporting");
const SessionStore = namespace("sessions");

@Component({
	components: {
		"vue-perfect-scrollbar": VuePerfectScrollbar,
	},
	filters: {
		formatDate: function (date) {
			return moment(date).format("MM/DD/YYYY HH:mm:ss");
		},
	},
})
export default class CameraSearchResults extends Vue {
	@Prop({ type: Array }) private searchResults: DeviceSearchModel[];

	@VideoReportingStore.State private auditEndpoint: string | null;
	@VideoReportingStore.State("videoReportingState") private currentState: VideoReportingStates;
	@VideoReportingStore.State private deviceEventRecords: DeviceEventRecords;

	@VideoReportingStore.Getter("getCurrentReportEventId") private currentReportEventId: number;
	@VideoReportingStore.Getter("getCurrentReportId") private currentReportId;

	@SessionStore.Getter private getSession: (sessionId: number | string) => string;
	@SessionStore.Action private updateSession: ({ resourceId, eventId }) => Promise<void>;

	private auditService: AuditService | null = null;

	private downloadingMedia = false;
	private downloadingMediaProgress: number = 0;

	private showDetails = {};

	// Helper function to turn setTimeout into an awaitable method
	private wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

	private getDeviceSearchResultIcon(deviceSearch: DeviceSearchModel) {
		let iconClass = "",
			iconTitle = "";

		if (deviceSearch.cameras.every((cam) => cam.successState == CameraRecordingState.Success)) {
			iconClass = "fa-check text-success";
			iconTitle = "All cameras were reviewed successfully";
		} else if (deviceSearch.cameras.every((cam) => cam.successState == CameraRecordingState.Failure)) {
			iconClass = "fa-times text-danger";
			iconTitle = "Failed to review cameras";
		} else {
			iconClass = "fa-check text-warning";
			iconTitle = "Some cameras were reviewed successfully";
		}

		return `<i data-cy="processed-icon" class="fas ${iconClass}" title="${iconTitle}"></i>`;
	}

	private getCameraResultIcon(camera: DeviceCamera) {
		let iconClass = "",
			iconTitle = "";

		if (camera.successState == CameraRecordingState.Success) {
			iconClass = "fa-check text-success";
			iconTitle = "Camera was reviewed successfully";
		} else if (camera.successState == CameraRecordingState.Failure) {
			iconClass = "fa-times text-danger";
			iconTitle = "Camera could not be reviewed";
		} else if (camera.successState == CameraRecordingState.NoClip) {
			iconClass = "fa-video-slash text-warning";
			iconTitle = "No clip was available for the date/time";
		}

		return `<i data-cy="camera-details-list-item-icon" class="fas ml-2 ${iconClass}" title="${iconTitle}"></i>`;
	}

	private toggleCameraDetails($idx: number) {
		let currValue = this.showDetails[$idx] || false;
		Vue.set(this.showDetails, $idx, !currValue);
	}

	private viewEvent() {
		let eventSearch = this.$router.resolve({ name: "eventsearch" });
		window.open(eventSearch.href + `/${this.currentReportEventId}`, "_blank");
	}

	private async downloadAll() {
		this.auditService = new AuditService(this.auditEndpoint);

		const videoReportId = this.currentReportId;
		const eventId = this.currentReportEventId;

		var allRecords = this.searchResults
			.map((result, index) => {
				let eventRecordId = this.deviceEventRecords[index];

				return result.cameras.map((camera) => {
					return {
						videoReportId,
						eventId,
						doorName: result.title,
						recordTime: result.date.toString(),
						durationRequested: result.maxDuration,
						cameraName: camera.title,
						cameraId: camera.deviceID,
						eventRecordId,
						cameraEventRecordId: camera.cameraEventRecordId,
					};
				});
			})
			.reduce((prev, curr) => prev.concat(curr), []);

		await this.updateSession({ resourceId: 2, eventId: this.currentReportEventId });
		var { data } = await this.auditService.downloadReport(this.getSession("2"), JSON.stringify(allRecords));

		this.downloadingMedia = true;
		this.downloadingMediaProgress = 0;

		await this.checkArchiveProgress(data);
	}

	/**
	 * Checks the archiving progress with the audit service. If the service is still archiving, we
	 * check again in a second. If the service indicates the archive is ready for download, we
	 * call downloadEventMediaArchive.
	 */
	public async checkArchiveProgress(eventId: number) {
		try {
			let { data } = await this.auditService.archiveIsReady(this.getSession(2), eventId);
			let { isReady, complete } = data;

			// If the media is still archiving
			if (!isReady && complete < 100) {
				this.downloadingMediaProgress = complete;

				// Wait a second before checking progress again
				await this.wait(1000);
				await this.checkArchiveProgress(eventId);
			} else {
				// The archive is ready, so clear our interval and download it
				await this.downloadEventMediaArchive(eventId);
			}
		} catch (err) {
			this.downloadingMedia = false;

			// Inform the user if we weren't able to download the events media
			this.$notify({
				type: "error",
				title: "Video Reporting",
				text:
					"Unable to check the status of the archive process - please try again later, or contact support if the problem persists.",
			});
		}
	}

	/**
	 * Downloads the archived media from the audit service for a given eventId.
	 */
	public async downloadEventMediaArchive(eventId: number) {
		try {
			let archive = await this.auditService.getArchive(this.getSession(2), eventId);

			const fileName = `VideoReport_${this.currentReportId}.zip`;
			const link = document.createElement("a");

			link.download = fileName;
			link.href = URL.createObjectURL(archive.data);
			link.click();
		} catch (err) {
			this.$notify({
				type: "error",
				title: "Video Reporting",
				text:
					"Unable to Download archived media - please try again later, or contact support if the problem persists.",
			});
		} finally {
			this.downloadingMedia = false;
		}
	}
}
